import Calendar from '../components/dashboard-calendar.svelte'
// import WeatherApp from '../components/dashboard-weather.svelte'
import { tns } from '../../node_modules/tiny-slider/src/tiny-slider'

export default {
	init() {
		// const $weatherWrap = $('#weather-wrap')
		// if ($weatherWrap.length) {
		// 	new WeatherApp({
		// 		target: document.getElementById('weather-wrap'),
		// 	})
		// }
		const $dashCalendar = $('#util-calendar')
		if ($dashCalendar.length) {
			new Calendar({
				target: document.getElementById('util-calendar'),
				props: $('#util-calendar').data(),
			})
		}
		const $dashFeatWrap = $('#dash-featured-article-wrap')
		if ($dashFeatWrap.length) {
			tns({
				container: '#dash-featured-article-wrap',
				items: 1,
				slideBy: 1,
				autoplay: true,
				nav: true,
				controls: true,
				touch: true,
				autoplayButtonOutput: false,
				autoplayHoverPause: true,
				speed: 750,
				controlsText: [
					'<span class="sr-only">prev</span><svg viewBox="0 0 32 52"><path fill-rule="evenodd" d="M11 26l21 21-5 5L2 28l-2-2 2-3L27 0l5 5-20 18"/></svg>',
					'<span class="sr-only">Next</span><svg viewBox="0 0 32 52"><path fill-rule="evenodd" d="M21 26L0 47l5 5 25-24 2-2-2-3L5 0 0 5l20 18"/></svg>',
				],
			})
		}
	},
	finalize() {
		// JavaScript to be fired on the home page, after the init JS
	},
}
